import axios from 'axios';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/dist/env/hosts';
var authenticatedAxios = axios.create({
    withCredentials: true,
    xsrfCookieName: null,
    xsrfHeaderName: null,
    baseURL: PRODUCTION_HOSTS.pixWix,
});
export default authenticatedAxios;
